import { notFound, permanentRedirect } from 'next/navigation';

import {
  buildListingHrefWithoutPage,
  isListingPageOutOfRange,
  parseListingPageParam,
} from '../parse-listing-page-param';

type ListingSearchParams = Record<string, string | string[] | undefined>;

/**
 * Resolves listing `page` for SSR pages:
 * - page=1 → permanentRedirect (308) to the same URL without `page`
 * - invalid page → notFound (404)
 * - missing / ≥2 → numeric page
 */
export const resolveListingPageNumber = (
  searchParams: ListingSearchParams,
  pathname: string,
): number => {
  const parsed = parseListingPageParam(searchParams.page);
  if (parsed.status === 'redirect_first') {
    permanentRedirect(buildListingHrefWithoutPage(pathname, searchParams));
  }
  if (parsed.status === 'invalid') {
    notFound();
  }
  return parsed.page;
};

export const assertListingPageInRange = (page: number, totalPages: number): void => {
  if (isListingPageOutOfRange(page, totalPages)) {
    notFound();
  }
};
